import { useTranslation } from 'react-i18next';
import { EmptyInboxIcon } from '@/Domain/components/Inbox/EmptyInbox/EmptyInbox.icon';

export const EmptyInbox = () => {
  const { t } = useTranslation('inbox_v2');

  return (
    <div className="flex-1 flex flex-col gap-3 items-center translate-y-1/4">
      <EmptyInboxIcon />
      <p className="font-medium text-sm text-foreground">{t('empty_conversation_list.title')}</p>
      <p className="text-sm text-foreground-subtle text-center">
        {t('empty_conversation_list.description')}
      </p>
    </div>
  );
};
